import React from 'react';
import {ContentDispatch} from 'framework';
import {connectWithCore} from 'framework/hocs';
import { Toggle } from 'componentLibrary';
import _ from 'lodash';

/* This is the configurable wrapper for toggle JS */
export class ConfigToggle extends React.Component {
  render() {
    const {contents, toggle, ifNot, entityType, entityId, setCurrentFieldList, propsToChild, ...restProps} = this.props;
    
    const additionalProps = {};
    _.each(propsToChild, key => { additionalProps[key] = _.get(restProps, key, key) });

    return (
      <Toggle toggle={toggle} ifNot={ifNot} entityType={entityType} entityId={entityId}>
        {_.map(contents, (conf, index) => {
          return <ContentDispatch key={conf.id || index} config={conf} setCurrentFieldList={setCurrentFieldList} {...additionalProps} />;
        })}
      </Toggle>
    );
  }
}

export default connectWithCore(ConfigToggle);
